
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48.03","height":"46.022"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 60","d":"M41.032 0h-34a1.048 1.048 0 00-1 1v12l-6 4c-.089.063.061-.086 0 0-.064.1.023-.115 0 0-.009.052 0-.053 0 0v28c0 .387.653.862 1 1 .082.033-.087-.009 0 0 .035 0-.036 0 0 0h46c.124 0-.117.047 0 0 .03-.012-.028.015 0 0 .079-.042-.067.065 0 0 .191-.185 1.005-.757 1-1V17c0-.019 0 .019 0 0-.006-.094-.964.091-1 0-.015-.038.02.036 0 0s.014.021 0 0c-.045-.066.057.051 0 0-.021-.019.023.017 0 0l-5-4V1a1.048 1.048 0 00-1-1zm-33 2h32v19l-16 10-16-10zm-2 13v4l-3-2zm-4 4l15 10-15 14zm1 25l15-14 5 3a3.317 3.317 0 001 0c.182 0-.159.1 0 0l5-3 15 14zm43-1l-15-14 15-10zm-1-26l-3 2v-4z","fill":"#172a55"}}),_c('path',{attrs:{"data-name":"Path 61","d":"M12.029 8h23a1 1 0 000-2h-23a1 1 0 000 2z","fill":"#2d498c"}}),_c('path',{attrs:{"data-name":"Path 62","d":"M36.029 12a1 1 0 00-1-1h-23a1 1 0 000 2h23a1 1 0 001-1z","fill":"#2d498c"}}),_c('path',{attrs:{"data-name":"Path 63","d":"M32.03 19a1 1 0 00-1-1h-14a1 1 0 000 2h14a1 1 0 001-1z","fill":"#2d498c"}})])
          )
        }
      }
    